export const mutationKeys = {
    updateUser: ['updateUser'],
};